import React, { useEffect, useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';
import Form from './Form';
import styles from '../../form/Form.module.css';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

import * as AlmoxarifadoAPI from '../../../api/almoxarifado';
import * as EmpresaAPI from '../../../api/empresa';
import * as TabelaAPI from '../../../api/tabela';
import * as FinanceiroAPI from '../../../api/financeiro';
import * as OperacaoAPI from '../../../api/operacao';
import * as PlantaoAPI from '../../../api/plantao';
import CRUDsAPI from '../../../api/CRUDs';

/* utils */
import { resolveEmpresaTabela } from '../../../utils/funcoes';
import { getEmpresaScope } from '../../../helpers/sessionEmpresa';

const CreateOrEdit = () => {
    const { parametro } = useContext(Context);
    //obtem o array de empresas vinculadas ou coloca a empresaId no array
    const { empresaId, empresaIds } = getEmpresaScope();
    const empresaTabelaId = resolveEmpresaTabela(parametro, empresaId);

    const [dados, setDados] = useState(() => ({
        empresaId: empresaId ?? null,
        ativo: true,
        cancelarMovimento: 'Manter',
        transformaMovimento: false,
        tipo: null,
    }));

    const [token] = useState(localStorage.getItem('token')) || '';
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);

    const [OptionsAlmoxarifado, setAlmoxarifado] = useState([]);
    const [OptionsForma, setForma] = useState([]);
    const [OptionsPrazo, setPrazo] = useState([]);
    const [OptionsConta, setConta] = useState([]);
    const [OptionsEmpresa, setEmpresa] = useState([]);
    const [OptionsDocumento, setDocumento] = useState([]);

    const [OptionsPlantaoTipo, setOptionsPlantaoTipo] = useState([]);
    const [OptionsSituacao, setOptionsSituacao] = useState([]);

    const pathname = '/ParametroOperacoes';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText');

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //enums e tabelas
    const [EnumContador, setEnumContador] = useState([]);
    const [EnumCancelarMovimento, setEnumCancelarMovimento] = useState([]);
    const [EnumTipo, setEnumTipo] = useState([]);
    const [EnumFreteTipoPadrao, setEnumFreteTipo] = useState([]);
    const [EnumFreteResponsavelFinanceiro, setEnumFreteResponsavel] = useState([]);
    const [EnumNatureza, setEnumNatureza] = useState([]);
    const [EnumTipoCalculoImposto, setEnumTipoCalculoImposto] = useState([]);
    //filtro de produtos
    const [EnumProdutoTipo, setEnumProdutoTipo] = useState([]);
    const [EnumProdutoFiltroMode, setEnumProdutoFiltroMode] = useState([]);

    //enums
    const consultaEnum = async (table, field, filter) => {
        const result = await TabelaAPI.enums(table, field, filter);

        if (table === 'operacaoParametros') {
            if (field === 'campoContador') {
                const operacao = dados.Operacao;

                const operacoes = await OperacaoAPI.retornaOperacoes({
                    balanco: operacao.balanco,
                    conferencia: operacao.conferencia,
                    entrada: operacao.entrada,
                    industria: operacao.industria,
                    inventario: operacao.inventario,
                    locacao: operacao.locacao,
                    manutencao: operacao.manutencao,
                    saida: operacao.saida,
                    servico: operacao.servico,
                });

                const siglasValidas = operacoes.map((op) => op.sigla.toLowerCase());

                // Filtra as siglas válidas e adiciona 'generico' no final do array
                const filtrado = (result || []).filter((item) => siglasValidas.includes(item?.toLowerCase()));
                filtrado.push('generico');

                setEnumContador(filtrado);
            } else if (field === 'tipo') {
                setEnumTipo(result ?? []);
            } else if (field === 'cancelarMovimento') {
                setEnumCancelarMovimento(result ?? []);
            } else if (field === 'freteTipoPadrao') {
                setEnumFreteTipo(result ?? []);
            } else if (field === 'freteResponsavelFinanceiro') {
                setEnumFreteResponsavel(result ?? []);
            } else if (field === 'produtoFiltroMode') {
                setEnumProdutoFiltroMode(result ?? []);
            } else if (field === 'produto_tipo') {
                setEnumProdutoTipo(result ?? []);
            } else if (field === 'tipoCalculoImposto') {
                setEnumTipoCalculoImposto(result ?? []);
            }
        } else if (table === 'operacaoTransformacoes') {
            if (field === 'natureza') {
                setEnumNatureza(result ?? []);
            }
        }
    };

    const consultaForma = async (obj) => {
        const result = await FinanceiroAPI.buscaForma(obj);
        setForma(result);
    };
    const consultaPrazo = async (tipo, formaId, nivel, prazoId, empresaId = dados.empresaId, prazoMedio) => {
        const result = await FinanceiroAPI.prazo(tipo, formaId, nivel, prazoId, empresaId, prazoMedio);
        setPrazo(result);
    };
    const consultaConta = async (empresaIds) => {
        const result = await FinanceiroAPI.buscaContaByEmpresaIds({ empresaIds });
        setConta(result);
    };
    const consultaEmpresa = async () => {
        const result = await EmpresaAPI.empresa(empresaId);
        setEmpresa(result);
    };
    const consultaDocumento = async () => {
        const result = await OperacaoAPI.obterDocumentos(empresaId);
        setDocumento(result);
    };
    const consultaAlmoxarifados = async (empresaId) => {
        try {
            const result = await AlmoxarifadoAPI.almoxarifadosByEmpresaId(empresaId);
            setAlmoxarifado(result);

            return result;
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response.data.message, error.response.data.type);
            return [];
        }
    };
    const consultaPlantaoTipo = async (empresaIds) => {
        const result = await PlantaoAPI.obterPlantaoTipos(empresaIds);
        setOptionsPlantaoTipo(result || []);
    };

    // consultar situações permitidas para anterior a transformação
    const consultaSituacao = async (obj) => {
        try {
            const data = await OperacaoAPI.obterOperacaoSituacaoByOpParamId(obj);
            setOptionsSituacao(data.situacoes || []);
        } catch (error) {
            console.error('Erro ao consultar situação de destino:', error);
        }
    };

    useEffect(() => {
        //consulta ENUMs
        if (dados.Operacao) {
            consultaEnum('operacaoParametros', 'campoContador', null);
        }
    }, [dados.Operacao]);
    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        //enums
        consultaEnum('operacaoParametros', 'tipoCalculoImposto', null);
        consultaEnum('operacaoParametros', 'cancelarMovimento', null);
        consultaEnum('operacaoParametros', 'tipo', null);
        consultaEnum('operacaoParametros', 'freteTipoPadrao', null);
        consultaEnum('operacaoParametros', 'freteResponsavelFinanceiro', null);

        consultaEnum('operacaoTransformacoes', 'natureza', null);

        //filtro de produtos
        consultaEnum('operacaoParametros', 'produtoFiltroMode', null);
        consultaEnum('operacaoParametros', 'produto_tipo', null);

        consultaEmpresa();
        consultaForma({ tipo: tipo, empresaId: dados.empresaId });
        consultaConta({ empresaIds });
        consultaPrazo(tipo, dados.formaId, '', '', dados.empresaId, '');
        consultaDocumento();
        consultaAlmoxarifados(empresaId); //obtem a empresa ou o array de empresas
        consultaPlantaoTipo(empresaIds);

        if (uuid && uuid !== 'null') {
            CRUDsAPI.operacaoParametro
                .consulta(uuid)
                .then((response) => {
                    setDados(response.data);
                })
                .catch((error) => {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, uuid]);

    useEffect(() => {
        if (!dados.id) {
            return;
        }
        consultaSituacao({ operacaoParametroId: dados.id });
    }, [dados.id]);

    async function managerDados(dados) {
        let urlNavigate = pathname;

        try {
            let response;

            if (uuid && uuid !== 'null') {
                response = await CRUDsAPI.operacaoParametro.editar(dados);
            } else {
                response = await CRUDsAPI.operacaoParametro.cadastrar(dados);

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';
                    urlNavigate = pathname + '/CreateOrEdit';
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response.data.message, error.response.data.type);
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                token={token}
                dados={dados}
                setDados={setDados}
                empresaId={empresaId}
                empresaIds={empresaIds}
                handleSubmit={managerDados}
                btnText={btnText}
                OptionsForma={OptionsForma}
                OptionsPrazo={OptionsPrazo}
                OptionsConta={OptionsConta}
                OptionsEmpresa={OptionsEmpresa}
                OptionsDocumento={OptionsDocumento}
                OptionsNatureza={EnumNatureza}
                OptionsAlmoxarifado={OptionsAlmoxarifado}
                OptionsPlantaoTipo={OptionsPlantaoTipo}
                OptionsSituacao={OptionsSituacao}
                EnumTipoCalculoImposto={EnumTipoCalculoImposto}
                EnumCancelarMovimento={EnumCancelarMovimento}
                EnumContador={EnumContador}
                EnumProdutoFiltroMode={EnumProdutoFiltroMode}
                EnumProdutoTipo={EnumProdutoTipo}
                EnumTipo={EnumTipo}
                EnumFreteTipoPadrao={EnumFreteTipoPadrao}
                EnumFreteResponsavelFinanceiro={EnumFreteResponsavelFinanceiro}
                caminhoVoltar={pathname}
                empresaTabelaId={empresaTabelaId}
            />
        </section>
    );
};
export default CreateOrEdit;
